import { writable } from 'svelte/store';

// Create a writable store that will hold the promotion object to be cloned.
// It starts as null, indicating no clone operation is in progress.
export const cloneStore = writable(null);

// Writable store for tracking background scanning status
export const scanStatus = writable({
  isScanning: false,
  error: null,
  data: null
});
